module.exports = __webpack_public_path__ + "static/media/generative_ai_icon.2fd1cde7.png";